import React, { useEffect, useState } from "react";
import Sidenavbar from "../../Sidenavbar";
import Topbar from "../../Topbar";
import "../../../styles/CommonStyle.scss";
import "../../../styles/Account.scss";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../BaseUrl";
import moment from "moment";
import { loggedInRole } from "../../LoginRole";
import AccessDenied from "../../../AccessDenied";
import { Col, Row } from "react-bootstrap";
import Footer from "../../Footer";
import { travelizeAuth } from "../../HeaderAuthentication";

function AccountDetails() {
  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));
  let subscribeDetails = JSON.parse(sessionStorage.getItem("usrlgndtls"));
  let subscriptionId = subscribeDetails?.subscriptionId;

  const [menuCollapse, setMenuCollapse] = useState(false);
  const [toggleshift, setToggleshift] = useState({ style: "" });
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);

  const toggleMenu = () => {
    if (menuCollapse) {
      setMenuCollapse(false);
      setToggleshift({ style: "" });
    } else {
      setMenuCollapse(true);
      setToggleshift({ style: "toggle-shift-left" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchSubscriptionDeatils();
  }, []);

  const fetchSubscriptionDeatils = () => {
    const requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/Subscription/GetAllSubscription?SubscriptionID=${subscriptionId}&PageSize=1&CurrentPage=1`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setSubscriptionDetails(res.result);
        } else {
          setSubscriptionDetails([]);
        }
      });
  };

  // Page navigation
  const Navigate = useNavigate();
  const goToBackPage = () => {
    Navigate(-1);
  };
  // page navigation

  return (
    <div id="main-page">
      {userDetails !== null && userDetails !== "" && loggedInRole !== 2 ? (
        <>
          {/* SIDEBAR START */}
          <Sidenavbar menuCollapse={menuCollapse} toggleshift={toggleshift} />
          {/* SIDEBAR END */}

          {/* TOPBAR START */}
          <Topbar
            toggleMenu={toggleMenu}
            menuCollapse={menuCollapse}
            toggleshift={toggleshift}
          />
          {/* TOPBAR END */}

          {/* MAIN BODY START */}
          <div className="page-wrapper">
            {/* PAGE CONTENT START */}
            <div className={`main-body ${toggleshift.style}`}>
              <div className="page-content">
                <div className="user-table">
                  <Row className="search-row">
                    <Col md={12} sm={12} xs={12} className="cat-col">
                      <div className="page-header-text-div">
                        <div className="back-btn" onClick={goToBackPage}>
                          <img
                            src="../../../../images/DefaultImages/back-btn-arrow.svg"
                            alt=""
                          />
                        </div>
                        <h6 className="page-header-text">ACCOUNT DETAILS</h6>
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* Filter and Header Section */}

                {/* LEADS TABLE START */}
                <div className="account-table">
                  <div className="account-subscription-data-row">
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-12">
                        <div className="current-subscription-part">
                          <div className="card subscription-card">
                            <div className="card-body">
                              <h5 className="card-title current-subscription">
                                CURRENT SUBSCRIPTION
                              </h5>
                              <span className="curr-sub-details">
                                <h6 className="subscription-details-head plan">
                                  Plan &nbsp;&nbsp;&nbsp;:
                                </h6>
                                <h6 className="subscription-details-data plan">
                                  {
                                    subscriptionDetails[0]?.subscriptionType
                                      ?.subscriptionName
                                  }
                                </h6>
                              </span>
                              <span className="curr-sub-details">
                                <h6 className="subscription-details-head no-of-users">
                                  Max Users &nbsp;&nbsp;&nbsp;:
                                </h6>
                                <h6 className="subscription-details-data plan">
                                  {subscriptionDetails[0]?.maxUserCount}
                                </h6>
                              </span>
                              <span className="curr-sub-details">
                                <h6 className="subscription-details-head sub-date">
                                  Subscription Date &nbsp;&nbsp;&nbsp;:
                                </h6>
                                <h6 className="subscription-details-data plan">
                                  {moment(
                                    subscriptionDetails[0]?.subscribedDate
                                  ).format("DD/MM/YYYY")}
                                </h6>
                              </span>

                              <span className="curr-sub-details">
                                <h6 className="subscription-details-head exp-date">
                                  Expiry Date &nbsp;&nbsp;&nbsp;:
                                </h6>
                                <h6 className="subscription-details-data plan">
                                  {moment(
                                    subscriptionDetails[0]?.expirydate
                                  ).format("DD/MM/YYYY")}
                                </h6>
                              </span>
                              <span className="curr-sub-details">
                                <h6 className="subscription-details-head days-left">
                                  Days Left &nbsp;&nbsp;&nbsp;:
                                </h6>
                                <h6 className="subscription-details-data plan">
                                  {subscriptionDetails[0]?.daysleft}
                                </h6>
                              </span>
                            </div>
                            <div className="subscribe-now-button mt-2">
                              {subscriptionDetails[0]?.daysleft < 30 ? (
                                <button className="btn btn-subscribe-now">
                                  SUBSCRIBE NOW
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* LEADS TABLE END */}

                {/* PAGE CONTENT END*/}
              </div>
            </div>

            {/* MAIN BODY END */}
          </div>
          <Footer />
        </>
      ) : (
        <AccessDenied />
      )}
    </div>
  );
}

export default AccountDetails;
